import RequestService from "@/configurations/AxiosConfig";
import { ILoginForm } from "@/types/type";

const controller = 'authentication/';

const endpoints = {
  signIn: 'signIn',
  validate: 'validate',
  forgotPassword: 'forgot-password',
  resetPassword: 'reset-password',
  logout: 'logout',
};

const AuthenticationService = {
  signIn: async (data: ILoginForm) => RequestService.post(controller.concat(endpoints.signIn), data),
  validate: () => RequestService.get(controller.concat(endpoints.validate)),
  forgotPassword: (data: string) => RequestService.post(controller.concat(endpoints.forgotPassword), data),
  resetPassword: (data: string) => RequestService.post(controller.concat(endpoints.resetPassword), data),
  logout: () => RequestService.get(controller.concat(endpoints.logout)),
};

export default AuthenticationService;
